<template>
  <router-link :to="url" class="nav-link">
    <span @click="hideMobile">
      <i :class="icon"></i> {{name}}
      <b-badge :variant="badge.variant">{{badge.text}}</b-badge>
    </span>
  </router-link>
</template>

<script>
  export default {
    name: 'sidebar-nav-link',
    props: {
      name: {
        type: String,
        default: ''
      },
      url: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      badge: {
        default: ''
      }
    },
    methods: {
      hideMobile () {
        if (document.body.classList.contains('sidebar-mobile-show')) {
          document.body.classList.toggle('sidebar-mobile-show')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SidebarNavLink.vue?31ffe2aa